// @flow
import React from 'react';

import { TCO_CLUSTER_LOCAL_RETENTION_BACKEND_FIELD_NAME } from '../../../constants';
import { TextField } from '../../../formik-utils/FormFields';
import { TEXT_NUMBER_INPUT_TYPE } from '../../../formik-utils/consts';
import { TCO_CLUSTER_LEVEL_INPUTS_CONFIG_MAP } from '../../../configuration/tco-cluster-inputs';

export const LocalRetentionContainer = () => {
  const { backendFieldName, displayName, icon, pathToFollowInValues, tooltip } =
    TCO_CLUSTER_LEVEL_INPUTS_CONFIG_MAP.get(TCO_CLUSTER_LOCAL_RETENTION_BACKEND_FIELD_NAME);

  return (
    <TextField
      fieldDisplayName={displayName}
      fieldName={backendFieldName}
      icon={icon}
      pathToFollowInValues={pathToFollowInValues}
      tooltip={tooltip}
      type={TEXT_NUMBER_INPUT_TYPE}
    />
  );
};
